<section class="no-pad-section">

    <div class="header-container">
        <div class="accordion-buttons">
            <!-- <input type="text" placeholder="Search..." class="search-bar" [(ngModel)]="searchText" /> -->
            <button class="accordion-btn" [class.active]="activeDropdown === 'submarket'"
                (click)="toggleDropdown('submarket')">
                Submarket <clr-icon shape="angle" class="dropdown-icon"></clr-icon>
            </button>
            <button class="accordion-btn" [class.active]="activeDropdown === 'propertyType'"
                (click)="toggleDropdown('propertyType')">
                Property Type <clr-icon shape="angle" class="dropdown-icon"></clr-icon>
            </button>
            <button class="accordion-btn" [class.active]="activeDropdown === 'building'"
                (click)="toggleDropdown('building')">
                Building <clr-icon shape="angle" class="dropdown-icon"></clr-icon>
            </button>
            <button class="accordion-btn" [class.active]="activeDropdown === 'land'" (click)="toggleDropdown('land')">
                Land <clr-icon shape="angle" class="dropdown-icon"></clr-icon>
            </button>
            <button class="accordion-btn" [class.active]="activeDropdown === 'saleDetail'"
                (click)="toggleDropdown('saleDetail')">
                Sale Detail <clr-icon shape="angle" class="dropdown-icon"></clr-icon>
            </button>
            <button class="accordion-btn" [class.active]="activeDropdown === 'distance'"
                (click)="toggleDropdown('distance')">
                Distance <clr-icon shape="angle" class="dropdown-icon"></clr-icon>
            </button>
            <!-- <select class="sort-dropdown" [(ngModel)]="sortOption">
                <option value="">Sort By</option>
                <option value="priceAsc">Sale Price - Low to High</option>
                <option value="priceDesc">Sale Price - High to Low</option>
                <option value="dateOldest">Sale Date - Oldest to Newest</option>
                <option value="dateNewest">Sale Date - Newest to Oldest</option>
                <option value="nraAsc">NRA - Low to High</option>
                <option value="nraDesc">NRA - High to Low</option>
                <option value="yearBuiltAsc">Year Built - Low to High</option>
                <option value="yearBuiltDesc">Year Built - High to Low</option>
                <option value="unitsAsc">Units - Low to High</option>
                <option value="unitsDesc">Units - High to Low</option>
            </select> -->



            <!-- <input type="text" placeholder="Search..." class="search-bar clr-input accordion-btn" [(ngModel)]="searchText"  />
            <select class="clr-input sort-dropdown" [(ngModel)]="sortOption">
                <option value="">Sort By</option>
                <option value="priceAsc">Sale Price - Low to High</option>
                <option value="priceDesc">Sale Price - High to Low</option>
                <option value="dateOldest">Sale Date - Oldest to Newest</option>
                <option value="dateNewest">Sale Date - Newest to Oldest</option>
                <option value="nraAsc">NRA - Low to High</option>
                <option value="nraDesc">NRA - High to Low</option>
                <option value="yearBuiltAsc">Year Built - Low to High</option>
                <option value="yearBuiltDesc">Year Built - High to Low</option>
                <option value="unitsAsc">Units - Low to High</option>
                <option value="unitsDesc">Units - High to Low</option>
            </select> -->

        </div>

        <div class="header-options">
            <label class="toggle-switch">
                <span>Open Map</span>
                <input type="checkbox" [(ngModel)]="showMap" (ngModelChange)="toggleMap($event)">
                <span class="slider"></span>
            </label>
        </div>
    </div>


    <!-- Dropdown Popups -->
    <div class="dropdown-popup" *ngIf="activeDropdown">

        <div class="dropdown-content">
            <ng-container *ngIf="activeDropdown === 'submarket'">
                <div class="filter-dropdown mt-2">
                    <ul class="columns-list-4">
                        <li *ngFor="let item of submarkets" class="list-item me-2">
                            <input type="checkbox" [checked]="propertySubmarket.includes(item.value)"
                            (change)="toggleSubmarket(item.value)">
                            <label class="form-check-label">{{ item.label }}</label>
                        </li>
                    </ul>
                </div>
            </ng-container>
            <ng-container *ngIf="activeDropdown === 'propertyType'">
                <div *ngFor="let property of PROPERTY_TYPES; let i = index">
                  
                  <!-- Categories without subtypes -->
                  <ng-container *ngIf="!property.subtypes">
                    <ul class="inline-list">
                      <li class="list-item">
                        <input
                          type="checkbox"
                          [checked]="propertyType.includes(property.value)"
                          (change)="togglePropertyType(property.value)"
                        />
                        <label class="form-check-label">{{ property.label }}</label>
                      </li>
                    </ul>
                  </ng-container>
              
                  <!-- Categories with subtypes -->
                  <div *ngIf="property.subtypes" class="mt-2">
                    <span class="heading">{{ property.label }}</span>
                    <ul class="columns-list-6">
                      <li *ngFor="let subtype of property.subtypes; let j = index" class="list-item">
                        <input
                          type="checkbox"
                          [checked]="propertyType.includes(subtype.value)"
                          (change)="togglePropertyType(subtype.value)"
                        />
                        <label class="form-check-label">{{ subtype.label }}</label>
                      </li>
                    </ul>
                    <hr />
                  </div>
                  
                </div>
              </ng-container>
              
              
            <ng-container *ngIf="activeDropdown === 'building'">
                <form [formGroup]="buildingForm" class="mt-2">
                    <div class="filter-dropdown">
                        <div class="row">
                            <!-- <div class="filter-column col-4">
                            <span class="filter-heading">Units</span>
                            <div class="filter-inputs">
                                <input type="number" formControlName="units_min" placeholder="Min">
                                <input type="number" formControlName="units_max" placeholder="Max">
                            </div>
                        </div>

                        <div class="filter-column col-4">
                            <span class="filter-heading">Stories</span>
                            <div class="filter-inputs">
                                <input type="number" formControlName="stories_min" placeholder="Min">
                                <input type="number" formControlName="stories_max" placeholder="Max">
                            </div>
                        </div> -->
                            <div class="filter-column col-4">
                                <span class="filter-heading">NRA</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="nra_min" placeholder="Min">
                                    <input type="number" formControlName="nra_max" placeholder="Max">
                                </div>
                            </div>
                            <div class="filter-column col-4">
                                <span class="filter-heading">GBA</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="gba_min" placeholder="Min">
                                    <input type="number" formControlName="gba_max" placeholder="Max">
                                </div>
                            </div>
                            <div class="filter-column col-4">
                                <span class="filter-heading">Year Built</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="year_built_min" placeholder="Min">
                                    <input type="number" formControlName="year_built_max" placeholder="Max">
                                </div>
                            </div>

                        </div>


                        <div class="column mt-2">
                            <span class="heading">Building Class</span>
                            <ul class="columns-list-6">
                                <li *ngFor="let item of buildingClasses" class="list-item">
                                    <input type="radio"
                                        [checked]="buildingForm.value?.building_class?.includes(item)"
                                        (change)="toggleSelection(buildingForm,'building_class', item)">
                                    <label class="form-check-label">{{ item }}</label>
                                </li>
                            </ul>
                        </div>

                        <!-- <div class="column mt-2">
                        <span class="heading">Under Construction</span>
                        <ul class="columns-list-4">
                            <li *ngFor="let item of underConstructionStatus" class="list-item">
                                <input type="checkbox"
                                    [checked]="buildingForm.value.under_construction.includes(item.value)"
                                    (change)="toggleSelection(buildingForm,'under_construction',item.value)">
                                <label class="form-check-label">{{ item.label }}</label>
                            </li>
                        </ul>
                    </div> -->

                        <div class="column mt-2">
                            <span class="heading">Qualitative Rating</span>
                            <div class="d-flex gap-4 flex-wrap">
                                <div *ngFor="let category of qualitativeRatings" class="dropdown-wrapper">
                                    <button type="button" class="dropdown-toggle1"
                                        (click)="toggleDropdown1(category.category)">
                                        {{ category.category }}
                                        <span [class.rotate]="dropdownStates[category.category]">&#9662;</span>
                                    </button>

                                    <div class="dropdown-content1" *ngIf="dropdownStates[category.category]">
                                        <div *ngFor="let item of category.values" class="form-check list-item">
                                            <input type="checkbox"
                                                [checked]="buildingForm.value[category.formControl]?.includes(item)"
                                                (change)="toggleQualitiveSelection(buildingForm,category.formControl, item)" />
                                            <label class="form-check-label">{{ item }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="activeDropdown === 'land'">
                <form [formGroup]="landForm" class="mt-2">
                    <div class="filter-dropdown">
                        <div class="row">
                            <div class="filter-column col-6">
                                <span class="filter-heading">Acres</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="land_acres_min" placeholder="Min">
                                    <input type="number" formControlName="land_acres_max" placeholder="Max">
                                </div>
                            </div>
    
                            <div class="filter-column col-6">
                                <span class="filter-heading">SQFT</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="land_sqft_min" placeholder="Min">
                                    <input type="number" formControlName="land_sqft_max" placeholder="Max">
                                </div>
                            </div>
                        </div>
    
    
                        <!-- <div class="column mt-2">
                            <span class="heading">Qualitative Rating</span>
                            <span class="sub-heading">Location</span>
                            <ul class="columns-list-3">
                                <li *ngFor="let item of ratingValues" class="list-item">
                                    <input type="checkbox" [checked]="landForm.value.qualitative_location.includes(item)"
                                        (change)="toggleQualitiveSelection(landForm,'qualitative_location',item)">
                                    <label class="form-check-label">{{ item }}</label>
                                </li>
                            </ul>
                        </div> -->
    
                        <div class="column mt-2">
                            <span class="heading">Zoning</span>
                            <ul class="columns-list-3">
                                <li *ngFor="let item of zoningOptions" class="list-item">
                                    <input type="radio" [checked]="landForm.value.zoning===item.value" formControlName="zoning" [value]="item.value">
                                    <label class="form-check-label">{{ item.label }}</label>
                                </li>
                            </ul>
                        </div>
    
    
                        <div class="column mt-2">
                            <span class="heading">Corner Lot</span>
                            <ul class="columns-list-6">
                                <li class="list-item">
                                    <input type="radio" [checked]="landForm.value.corner_lot==='yes'"
                                        (change)="toggleSelection(landForm,'corner_lot','yes')">
                                    <label class="form-check-label">Yes</label>
                                </li>
                                <li class="list-item">
                                    <input type="radio" [checked]="landForm.value.corner_lot==='no'"
                                        (change)="toggleSelection(landForm,'corner_lot','no')">
                                    <label class="form-check-label"> No</label>
                                </li>
                                <li class="list-item">
                                    <input type="radio" [checked]="landForm.value.corner_lot===''"
                                        (change)="toggleSelection(landForm,'corner_lot','')">
                                    <label class="form-check-label">N/A</label>
                                </li>
                            </ul>
                        </div>
    
    
                        <!-- <div class="column mt-2">
                            <span class="heading">Hide Active Listing</span>
                            <ul>
                                <li class="list-item">
                                    <input type="radio" [checked]="landForm.value.hide_active_listing==='yes'"
                                        (change)="toggleSelection(landForm,'hide_active_listing','yes')">
                                    <label class="form-check-label">Hide Properties For Sale</label>
                                </li>
    
                            </ul>
                        </div> -->
    
                    </div>
                </form>
            </ng-container>
            <ng-container *ngIf="activeDropdown === 'saleDetail'">
                <form [formGroup]="saleDetailForm" class="mt-2">
                    <div class="filter-dropdown">
                        <div class="row">
                            <div class="filter-column col-6">
                                <span class="filter-heading">Sale Date</span>
                                <div class="filter-inputs">
                                    <input type="date" formControlName="sale_date_start" placeholder="Min">
                                    <input type="date" formControlName="sale_date_end" placeholder="Max">
                                </div>
                            </div>
                            <div class="filter-column col-6">
                                <span class="filter-heading">Sale Price</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="sale_price_min" placeholder="Min">
                                    <input type="number" formControlName="sale_price_max" placeholder="Max">
                                </div>
                            </div>
                            <div class="filter-column col-6">
                                <span class="filter-heading">Price Per SQFT</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="sale_price_psf_min" placeholder="Min">
                                    <input type="number" formControlName="sale_price_psf_max" placeholder="Max">
                                </div>
                            </div>
                            <!-- 
                            <div class="filter-column col-6">
                                <span class="filter-heading">Price Per Unit</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="pricePerUnitMin" placeholder="Min">
                                    <input type="number" formControlName="pricePerUnitMax" placeholder="Max">
                                </div>
                            </div> -->
    
    
                            <!-- <div class="filter-column col-6">
                                <span class="filter-heading">Price Per Land SQFT</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="pricePerLandSqftMin" placeholder="Min">
                                    <input type="number" formControlName="pricePerLandSqftMax" placeholder="Max">
                                </div>
                            </div> -->
    
                            <!-- <div class="filter-column col-6">
                                <span class="filter-heading">Price Per Land Acres</span>
                                <div class="filter-inputs">
                                    <input type="number" formControlName="pricePerLandAcresMin" placeholder="Min">
                                    <input type="number" formControlName="pricePerLandAcresMax" placeholder="Max">
                                </div>
                            </div> -->
                        </div>
    
    
                        <!-- <div class="column mt-2">
                            <span class="sub-heading">Location</span>
                            <ul class="columns-list-3">
                                <li *ngFor="let item of ratingValues" class="list-item">
                                    <input type="checkbox" [checked]="saleDetailForm.value.qualitative_location.includes(item)"
                                        (change)="toggleQualitiveSelection(saleDetailForm,'qualitative_location',item)">
                                    <label class="form-check-label">{{ item }}</label>
                                </li>
                            </ul>
                        </div> -->
    
                        <!-- <div class="column mt-2">
                            <span class="heading">Right Transferred</span>
                            <ul class="columns-list-3">
                                <li *ngFor="let item of zoningOptions" class="list-item">
                                    <input type="checkbox"
                                        [checked]="saleDetailForm.value.rightTransferred.includes(item.value)"
                                        (change)="toggleSelection(saleDetailForm,'rightTransferred', item.value)">
                                    <label class="form-check-label">{{ item.label }}</label>
                                </li>
                            </ul>
                        </div> -->
    
                    </div>
    
    
                </form>
            </ng-container>
            <ng-container *ngIf="activeDropdown === 'distance'">
                <div class="filter-dropdown">
                    <div class="row">
                        <div class="distance-filter-container">
                            <label class="distance-label">Distance (in meters)</label>
                            <div class="distance-slider-wrapper">
                                <input type="range" [(ngModel)]="radius" class="distance-slider" min="1000" max="500000" />
                                <span class="distance-value">{{ radius | number }} m</span>
                            </div>
                        </div>
                    </div>
                </div>
                </ng-container>
            <div class="dropdown-footer mt-2">
                <button class="btn btn-danger" (click)="resetFilters()">Reset Filters</button>
                <button class="btn btn-primary" (click)="submitFilter()">Apply Filters</button>
            </div>
        </div>


    </div>
</section>

<section class="table-section"><div class="clr-row">
    <div class="clr-col-4" *ngIf="showMap">
      <app-google-maps
        [locationDetails]="mapCenter"
        [showMarkers]="true"
        [locationDetails]="locations">
      </app-google-maps>
    </div>
  
    <div [ngClass]="showMap ? 'clr-col-8' : 'clr-col-12'">
  
            <clr-datagrid #scrollContainer class="scroll-container">
                <clr-dg-column style="width:50px">
                    <input type="checkbox" [(ngModel)]="selectAll" (ngModelChange)="selectAllProerties($event)"/>
                </clr-dg-column>

                <ng-container *ngFor="let col of columns">
                    <clr-dg-column *ngIf="!col.is_summary">
                        {{ col.name }}
                    </clr-dg-column>
                </ng-container>

                <ng-container *ngIf="!properties?.length">
                    <clr-dg-row>
                    <clr-dg-cell [attr.colspan]="columns.length+1" class="text-center w-auto">
                        No Data Available
                      </clr-dg-cell>
                    </clr-dg-row>
                </ng-container>

                <clr-dg-row *ngFor="let property of properties">
                    <clr-dg-cell  style="width:50px">
                        <input
                        type="checkbox"
                        [checked]="isSelected(property)"
                        (change)="onSelectionChange($event.target.checked, property)"
                      />
                  </clr-dg-cell>
                    <!-- <ng-container *ngFor="let col of columns">
                        <ng-container *ngIf="(col.visible===true || col.visible==='true') && !col.is_summary">
                        <ng-container *ngIf="col.unit !== 'custom'; else customCell">
                            <span style="display: flex; justify-content: space-between; width: 100%;">
                                <span>{{ getDisplayValue(property, col) }}</span>     
                          </span>
                        </ng-container>
                        <ng-template #customCell>
                            <div [innerHTML]="renderCell({ field: col.field, data: property })"></div>
                          </ng-template>
                        </ng-container>
                    </ng-container> -->
                    <ng-container *ngFor="let col of columns">
                        <clr-dg-cell *ngIf=" !col.is_summary">
                            <span *ngIf="col.field!=='address'">{{ property[col.field] || 'N/A'}}</span>
                            <span *ngIf="col.field==='address'">{{ property['address_street_1'] || 'N/A'}}</span>
                        </clr-dg-cell>
                    </ng-container>
                </clr-dg-row>
                <clr-dg-footer>
                    <clr-dg-pagination
                        [clrDgTotalItems]="totalCount"
                        [clrDgPageSize]="pageSize"
                        [(clrDgPage)]="currentPage"
                        (clrDgPageChange)="onPageChanged($event)">
                    </clr-dg-pagination>
                    </clr-dg-footer>            

            </clr-datagrid>

        </div>
    </div>

</section>